module.exports = __webpack_public_path__ + "static/valentines-43d3a950c7564413ca2f0715e198d2d7.jpg";